"use strict";
const isNumericFormat = (format) => ['integer', 'integerNoSeparator', 'decimal', 'percentage', 'currency', 'Numeric'].includes(format);
module.exports = {
    isNumericFormat,
};
//# sourceMappingURL=attributes.js.map